import { gql } from '@apollo/client';

const GET_USER_YTD_MILEAGE = gql`
query loadYtdMileage  ($userGuid: String) {
  loadYtdMileage (employeeGUID: $userGuid)
}`;

export default GET_USER_YTD_MILEAGE;